<template>
    <div>
        <v-card class="category-card mb-1 elevation-3" @click="$emit('input', categoryKey)">
            <v-card-title primary-title class="font-weight-bold pt-3" style="height:5em;">
                {{category.categoryFeaturePhrase}}
            </v-card-title>
            <v-card-text class="pa-0">
                <div class="category-icon" :style="'background-image:url('+imageUrl+');'"></div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import firebase from '@/firebase.js';
export default {    
    props:['category', 'categoryKey'],

    data() {
        return {
            imageUrl:''
        }
    },

    created() {
        firebase.storage().ref().child('/categories/'+this.categoryKey).child('/icon.png').getDownloadURL().then((url)=>{
            this.imageUrl = url;
        });
    }
}
</script>

<style>
    .category-icon {
        width: 100%;
        height: 160px;
        margin: 0 auto;
        background-size: contain;
        background-position: bottom center;
    }

    .category-card:hover {
        color: #ddd!important;
        background-color: #100429!important;
    }

    .category-card:hover .category-icon {
        opacity: 0.75;
    }
</style>
